import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';

export const selectOfflineSales = (state: RootState) => state.offlineSales;

export const selectOfflineSalesFilters = createSelector([selectOfflineSales], ({ filters }) => filters);

export const selectOfflineSalesData = createSelector([selectOfflineSales], ({ data, dataRequestId }) => ({
  data,
  loading: !!dataRequestId,
}));
